<template>
    <div>
        <my-form class="form-page" v-model="form" table label-width="180px" @cancle="cancleHandler" :submit-url="`${getGetters('ageUrl')}/DingBiao/ZbHxr/hxradd.json`">
            <el-form-item label="相关标段"  prop="bdname" :rules="newRule('相关标段', 'required')" class="table-full-row">
                <my-select
                    :disabled="edit"
                    v-model="form.bdcode"
                    :data="model.bdlist"
                    :props="{value:'bdcode',label:'bdname'}"
                    2way="bdname"
                    :bdname.sync="form.bdname"
                    @select="bdChange" style="width:100%">
                </my-select>
            </el-form-item>
            <el-form-item label="候选人列表" prop="hxrdwcode" :rules="newRule('候选人', 'required')" class="table-full-row" v-if="model.zb">
                <my-select
                    v-model="form.hxrdwcode"
                    :data="zbhxrlist"
                    :props="{value:'hxrdwcode',label:'hxrdwname'}"
                    2way="hxrdwname"
                    :bdname.sync="form.hxrdwname"
                    @select="hxrchange" style="width:100%">
                </my-select>
            </el-form-item>
            <el-form-item label="是否联合体" :class="{'table-full-row': form.islht==='0'}" prop="islht" :rules="newRule('是否联合体', 'required')">
                <el-radio v-model="form.islht" label="1">是</el-radio>
                <el-radio v-model="form.islht" label="0">否</el-radio>
            </el-form-item>
            <el-form-item label="联合体成员" prop="lhtcy" :rules="newRule('联合体成员', 'required','sensitiveWords')" v-if="form.islht==='1'">
                <el-input v-model="form.lhtcy"></el-input>
            </el-form-item>
            <el-form-item label="中标候选人统一信用代码" prop="hxrorgcode" :rules="newRule('中标候选人统一信用代码', 'required','sensitiveWords')" v-if="model.zb">
                <el-input v-model="form.hxrorgcode"></el-input>
            </el-form-item>
            <el-form-item label="统一信用代码" prop="hxrorgcode" :rules="newRule('统一信用代码', 'required','sensitiveWords')" v-if="!model.zb">
                <el-input v-model="form.hxrorgcode"></el-input>
            </el-form-item>
            <el-form-item label="单位名称" prop="hxrdwname" :rules="newRule('单位名称', 'required','sensitiveWords')">
                <el-input v-model="form.hxrdwname"></el-input>
                <my-tag type="danger" style="margin-top:5px" v-if="model.ishbpsp&&form.islht=='1'">
                   <i class="el-icon-warning"></i> 如需在河北省政府采购网公布中标单位联合体成员信息，请自行在中标候选人单位名称处补全联合体成员。
                </my-tag>
            </el-form-item>
            <el-form-item label="候选人所属地区" class="table-full-row" v-if="!model.zb">
                <my-cascader
                    v-model="form.citycode"
                    class="cityText"
                    :url="`${getGetters('ageUrl')}/common/getcitytree.json`" 
                    placeholder="选择候选人所属地区" 
                    @change="getCity"
                ></my-cascader>
            </el-form-item>
            <el-form-item label="报价类型" prop="bjlx" :rules="newRule('报价类型', 'required')">
                <el-select v-model="form.bjlx" placeholder="请选择报价类型" style="width:100%">
                    <el-option
                    v-for="item in bjlxList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="是否进行过投标报价算术性修正"  prop="ssxxz" :rules="newRule('是否进行过投标报价算术性修正', 'required')">
                <el-radio v-model="form.ssxxz" label="1">是</el-radio>
                <el-radio v-model="form.ssxxz" label="0">否</el-radio>
            </el-form-item>
            <el-form-item label="中标候选人排名" prop="hxrpm" :rules="newRule('中标候选人排名', 'required','number')">
                <el-input-number :min="1" v-model.number="form.hxrpm" style="width:200px"></el-input-number>
            </el-form-item>
            <el-form-item label="投标价格(元)" prop="tbjg" :rules="newRule('投标价格', 'required')" v-if="form.bjlx==='1'">
                <el-input-number
                    :min="0"
                    v-model.number="form.tbjg" 
                    @blur="comparison" 
                    :precision="2"
                    style="width:100%">
                    </el-input-number>
                    <my-tag type="danger" style="display:block" v-if="tbjgShow">
                        <div class="reason">
                            请确认金额是否录入正确，正确可忽略。
                        </div>
                    </my-tag>
                    <my-tag type="danger" style="display:block" v-if="form.ssxxz==='0'&&comparisonText!==''">
                        <div class="reason">
                            {{comparisonText}}
                        </div>
                    </my-tag>
            </el-form-item>
            <el-form-item label="投标价格" prop="tbbj" :rules="newRule('投标价格', 'required','sensitiveWords')" v-if="form.bjlx!=='1'">
                <el-input v-model="form.tbbj"></el-input>
            </el-form-item>

            <template v-if="form.ssxxz==='1'">
                <template v-if="form.bjlx==='1'">
                    <el-form-item label="评标价格(元)" prop="pbjg" :rules="newRule('评标价格', 'required')">
                        <el-input-number v-model.number="form.pbjg" style="width:200px"></el-input-number>
                    </el-form-item>
                    <el-form-item label="中标价格(元)" prop="zbjg" :rules="newRule('中标价格', 'required')">
                        <el-input-number v-model.number="form.zbjg" @blur="comparison" style="width:200px"></el-input-number>
                        <my-tag type="danger" style="display:block" v-if="form.ssxxz==='1'&&comparisonText!==''">
                            <div class="reason">
                                {{comparisonText}}
                            </div>
                        </my-tag>
                    </el-form-item>
                </template>
                <template v-if="form.bjlx!=='1'">
                    <el-form-item label="评标价格" prop="pbbj" :rules="newRule('评标价格', 'required','sensitiveWords')">
                        <el-input v-model="form.pbbj" style="width:200px"></el-input>
                    </el-form-item>
                    <el-form-item label="中标价格" prop="zbbj" :rules="newRule('中标价格', 'required','sensitiveWords')">
                        <el-input v-model="form.zbbj"></el-input>
                    </el-form-item>
                </template>
            </template>

            <el-form-item label="评分结果" prop="pfjg" :rules="newRule('评分结果', 'required','sensitiveWords')" class="table-full-row">
                <el-input v-model="form.pfjg" type="textarea" :autosize="{ minRows: 4, maxRows: 10}"></el-input>
            </el-form-item>
            <el-form-item label="工期" prop="construction_period" :rules="newRule('工期', 'required','sensitiveWords')" class="table-full-row">
                <el-input v-model="form.construction_period"></el-input>
            </el-form-item>
            <el-form-item label="项目负责人" prop="pro_header" :rules="newRule('项目负责人', 'required','sensitiveWords')">
                <el-input v-model="form.pro_header"></el-input>
            </el-form-item>
            <el-form-item label="项目负责人证书及编号" prop="certificate" :rules="newRule('项目负责人证书及编号', 'required','sensitiveWords')">
              <el-input v-model="form.certificate"></el-input>
            </el-form-item>
            <el-form-item label="个人业绩" prop="results" :rules="newRule('个人业绩', 'required','sensitiveWords')" class="table-full-row">
                <el-input v-model="form.results" type="textarea" :autosize="{ minRows: 4, maxRows: 10}"></el-input>
            </el-form-item>
            <el-form-item label="中标候选人在投标文件中填报的资格能力条件" prop="tender_ability" :rules="newRule('中标候选人在投标文件中填报的资格能力条件', 'required','sensitiveWords')" class="table-full-row">
                <el-input v-model="form.tender_ability" type="textarea" :autosize="{ minRows: 4, maxRows: 10}"></el-input>
            </el-form-item>
            <el-tag
                type="danger">
                    请认真核对数据，确保数据正确!
            </el-tag>
            <template slot="btn" slot-scope="scope">
                <el-button @click="saveHandler(1, scope.submitHandler)" type="primary" icon="el-icon-circle-check">
                    提交
                </el-button>
                <el-button @click="saveHandler(0, scope.submitHandler)" type="warning" icon="el-icon-remove-outline">
                    暂存
                </el-button>
                <el-button icon="el-icon-circle-close" @click="scope.cancleHandler">取消</el-button>
                
            </template>
           
        </my-form>
         
    </div>
</template>

<script>
import FORM_PAGE_MIXIN from '@views/mixins/form-page'


export default {
    mixins: [ FORM_PAGE_MIXIN],

    data: () => ({
        submitUrl:'',
        model:{},
        form: {
            islht:'0',
            ssxxz:'0',
            bjlx:'1',
            hxrpm:'',
            hxrdwname:'',
            hxrorgcode:'',
            tbjg:'',
            construction_period:'',
            lhtcy:'',
            pfjg:'',
            tbbj:'',
        },
        zbhxrlist:[],
        bjlxList:[
            {value:'1',label:'金额'},
            {value:'2',label:'费率/比率/优惠率/合格率等'},
            {value:'3',label:'单价'},
            {value:'4',label:'其他形式'},
        ],
        comparisonText:'',
        edit:false,
        tbjgShow:false,
    }),
    watch: {
        'form.tbjg':function(n){
            if(this.getQuery('zhhxrcode')){
                this.comparison()
            }
        }
    },
    methods: {
        // 获取城市name
        getCity(e){
            this.form.cityname = e[0].pathLabels.join('-')
        },
        saveHandler(type, cb){
            this.form.shbj = type;
            this.form.bzcode = '156';
            this.form.bzname = '人民币';
            this.form.jgdwcode = '1';
            this.form.jgdwname = '元';
            if(this.form.bjlx==='1'&&this.form.ssxxz==='0'){
                this.form.pbjg = this.form.tbjg
                this.form.zbjg = this.form.tbjg
            }else if(this.form.bjlx!=='1'&&this.form.ssxxz==='0'){
                this.form.pbbj = this.form.tbbj
                this.form.zbbj = this.form.tbbj
            }
            if(!this.model.zb){
                this.form.hxrdwcode = this.form.hxrorgcode
            }
            cb && cb();
        },
        // 获取候选人列表
        bdChange(val){
            this.$get(`${this.getGetters('mngUrl')}/DingBiao/ZbHxr/queryHxrList.json`,{
                bdcode:this.form.bdcode
            }, (data, res) => {
                this.zbhxrlist = data
                if(val!==1){
                    this.form.hxrdwcode = ''
                    this.form.hxrdwname = ''
                    this.resetField()
                }
            });
        },
        resetField(){
            this.form.islht = '0'
            this.form.bjlx = '1'
            this.form.hxrorgcode = ''
            this.form.hxrpm = ''
            this.form.tbjg = ''
            this.form.tbbj = ''
            this.form.pfjg = ''
            this.form.construction_period = ''
            this.form.lhtcy = ''
            this.tbjgShow = false
        },
        // 获取候选人信息
        hxrchange(){
            if(this.form.hxrdwcode){
                this.$get(`${this.getGetters('mngUrl')}/DingBiao/ZbHxr/queryHxrPm.json`,{
                    tbdwcode:this.form.hxrdwcode,
                    bdcode:this.form.bdcode
                }, (data, res) => {
                    if(data.hxrpm.length > 0){
                        this.form.hxrpm = data.hxrpm[0].tbdworder;
                        this.form.pfjg = data.hxrpm[0].score;
                    }
                    this.form.hxrdwname = data.tbdwname;
                    this.form.hxrorgcode = data.orgcode;
                    if (data.bjlx) {
                        this.form.bjlx = data.bjlx;
                        if (data.bjlx === '1') {
                            this.form.tbjg = data.tbbj;
                        }
                        else {
                            this.form.tbbj = data.tbbj;
                        }
                    }
                    this.form.construction_period = data.gq;
                    if (!data.jointventure) {
                        this.form.islht = '0';
                    } else {
                        this.form.islht = '1';
                    }
                    this.form.lhtcy = data.jointventure;
                    this.comparison();
                });
                // 获取单位信息
                // this.$get(`${this.getGetters('mngUrl')}/DingBiao/ZbHxr/get_dwname.json`,{
                //     dwcode:this.form.hxrdwcode,
                //     bdcode:this.form.bdcode
                // }, (data, res) => {
                //     this.form.hxrdwname = data.tbdwname
                //     this.form.hxrorgcode = data.tbdwcode
                //     this.form.tbjg = data.e_tbbj
                //     this.form.construction_period = data.e_gq
                //
                //     if(!data.jointventure){
                //         this.form.islht = '0'
                //     }else{
                //         this.form.islht = '1'
                //     }
                //     this.form.lhtcy = data.jointventure
                // });
            }
            
        },
        // 投标价格 中标价格比对
        comparison(){
            var num = ''
            // 判断投标价格是否小于5千 大于5亿
            if(this.form.tbjg<50000||this.form.tbjg>=5e8){
                this.tbjgShow = true;
            }else{
                this.tbjgShow = false;
            }

            if(this.form.bdcode&&(this.form.tbjg!=='0'||this.form.zbjg!=='0')){
                if(this.form.ssxxz==='0'){
                    num = this.form.tbjg
                }else{
                    num = this.form.zbjg
                }

                this.$get(`${this.getGetters('mngUrl')}/DingBiao/ZbHxr/checkPrice.json`,{
                    price:num,
                    bdcode:this.form.bdcode
                }, (data, res) => {
                    if(data==='203'){
                        this.comparisonText = '输入价格小于标段信息中“标段投资概算”的50%，请确认是否正确，正确可忽略。'
                    }else if(data==='200'){
                        this.comparisonText = ''
                    }else if(data==='202'){
                        this.comparisonText = '输入价格大于标段信息中“标段投资概算”，请确认是否正确，正确可忽略。'
                    }
                });
                
            }
        }
    },
    created() {
        var that = this
        if(!that.getQuery('zhhxrcode')){
            this.jspInit(`${this.getGetters('ageUrl')}/DingBiao/ZbHxr/hxradd.json`, {
                zbprocode:this.getQuery('procode')
            }, data => {
                that.model = data
            });
        }else{
            this.jspInit(`${this.getGetters('ageUrl')}/DingBiao/ZbHxr/hxredit.json`,{
                zhhxrcode:this.getQuery('zhhxrcode')
            }, data => {
                that.edit = true
                that.model = data
                that.form = data.json_model
                that.bdChange(1)
            });
        }
        
    },
    mounted() {
       
    },
}
</script>

<style scoped lang="scss">
    /deep/ .el-tag--danger{ font-size: 14px;margin:10px auto 0;display:block;}
</style>
